import type { CSSProperties } from "react";
import { IMPORT_JOB_STATUS_SPHERE, IMPORT_JOB_STATUS_UNKNOWN } from "../lib/statusPillColors";
import styles from "./ImportJobStatusDot.module.css";

export type ImportJobStatus =
  | "PENDING"
  | "RUNNING"
  | "COMPLETED"
  | "FAILED"
  | "CANCELLED"
  | string;

const IMPORT_STATUS_SPHERE = IMPORT_JOB_STATUS_SPHERE;

function importStatusMeta(status: ImportJobStatus) {
  const key = String(status || "").toUpperCase();
  return (
    IMPORT_STATUS_SPHERE[key] ?? {
      ...IMPORT_JOB_STATUS_UNKNOWN,
      label: status || IMPORT_JOB_STATUS_UNKNOWN.label,
    }
  );
}

export function importJobStatusLabel(status: ImportJobStatus): string {
  return importStatusMeta(status).label;
}

export function ImportJobStatusDot({
  status,
  size = 11,
  className,
}: {
  status: ImportJobStatus;
  size?: number;
  className?: string;
}) {
  const meta = importStatusMeta(status);
  const active = status === "PENDING" || status === "RUNNING";
  const style: CSSProperties & { "--pulse-ring"?: string } = {
    width: size,
    height: size,
    background: meta.bg,
    borderColor: meta.border,
    "--pulse-ring": meta.pulse ?? meta.border,
  };

  return (
    <span
      className={[styles.dot, active ? styles.dotActive : "", className]
        .filter(Boolean)
        .join(" ")}
      style={style}
      title={`${meta.label} — ${meta.hint}`}
      aria-label={`${meta.label} — ${meta.hint}`}
      role="img"
    />
  );
}
